import { ref } from 'vue';

// 运维平台专用 Toast 状态（独立于用户界面）
const opsToasts = ref([]);

/**
 * 添加 Toast 提示
 * @param {string} msg - 提示消息
 * @param {string} type - 类型：success, error, warning, info
 * @param {number} duration - 显示时长（毫秒），默认 3000
 */
export function addOpsToast(msg, type = 'info', duration = 3000) {
  const id = Date.now() + Math.random();
  opsToasts.value.push({ id, msg, type, duration });
  
  if (duration > 0) {
    setTimeout(() => {
      removeOpsToast(id);
    }, duration);
  }
  
  return id;
}

/**
 * 移除 Toast
 */
export function removeOpsToast(id) {
  opsToasts.value = opsToasts.value.filter(t => t.id !== id);
}

/**
 * 成功提示
 */
export function showOpsSuccessToast(msg, duration = 2000) {
  return addOpsToast(msg, 'success', duration);
}

/**
 * 错误提示
 */
export function showOpsErrorToast(msg, duration = 3000) {
  return addOpsToast(msg, 'error', duration);
}

/**
 * 警告提示
 */
export function showOpsWarningToast(msg, duration = 2500) {
  return addOpsToast(msg, 'warning', duration);
}

/**
 * 信息提示
 */
export function showOpsInfoToast(msg, duration = 2000) {
  return addOpsToast(msg, 'info', duration);
}

/**
 * 使用 Toast 的 composable（运维平台专用）
 */
export function useOpsToast() {
  return {
    toasts: opsToasts,
    addToast: addOpsToast,
    removeToast: removeOpsToast,
    showSuccessToast: showOpsSuccessToast,
    showErrorToast: showOpsErrorToast,
    showWarningToast: showOpsWarningToast,
    showInfoToast: showOpsInfoToast
  };
}

